module.exports = __webpack_public_path__ + "img/symbol_10_x12.0ce4bd53.png";